export const FULL_DATE_TIME_FORMAT = 'MMMM D, YYYY [at] h:mm A'

export const SHORT_WEEKDAY_FORMAT = 'ddd'

export const MONTH_YEAR_FORMAT = 'MMMM YYYY'
